import PropTypes from 'prop-types';
import { map } from "lodash";

const RefinancingModalErrorComponent = (props) => {
  const { error, resetRefinancingCases } = props;

  const handleResetError = () => resetRefinancingCases();

  return (
    <div className='crm-invalid-container'>
      <div className='crm-invalid-title'>Error al intentar subir el documento:</div>
      <div className='crm-invalid-title'>
        {error.length === 1 ? <span>Se encontró un dato incorrecto</span> : <span>Se econtraron <strong>{error.length}</strong> datos incorrectos</span>}
      </div>
      <div className='crm-table-container'>
        <table>
          <thead><tr><th>Fila</th><th>Columna</th><th>Error</th></tr></thead>
          <tbody>
            {map(error, e => <tr><td>{e.row}</td><td>{e.column}</td><td>{e.message}</td></tr>)}
          </tbody>
        </table>
      </div>
      <div className='crm-invalid-buttons-container'>
        <button type="button" className='crm-black-btn' onClick={handleResetError}>
          Volver
        </button>
      </div>
    </div>
  );
}

RefinancingModalErrorComponent.propTypes = {
  resetRefinancingCases: PropTypes.func,
  error: PropTypes.array
};

export default RefinancingModalErrorComponent;